import React from "react";
import { NavLink } from "react-router-dom";

const SideBar = ({ user }) => {
  return (
    <React.Fragment>
      {user && (
        <ul
          className="navbar-nav bg-gradient-custom sidebar sidebar-dark accordion"
          id="accordionSidebar"
        >
          <NavLink
            className="sidebar-brand d-flex align-items-center justify-content-center"
            to="/"
          >
            <div className="sidebar-brand-icon rotate-n-0">
              <img
                height="50px"
                src={require("../assets/images/jeriod_logo.png")}
                alt=""
              />
            </div>
            {/* <div className="sidebar-brand-text mx-3">Voyance</div> */}
          </NavLink>

          <br />
          <hr className="sidebar-divider my-0" />

          <div className="sidebar-heading">Menu</div>

          <li className="nav-item active">
            <NavLink className="nav-link" to="/">
              <i className="fa fa-fw fa-tachometer-alt" />
              <span>Dashboard</span>
            </NavLink>
          </li>

          <hr className="sidebar-divider" />
          <div className="sidebar-heading">Accounts</div>

          <li className="nav-item">
            <NavLink className="nav-link" to="/users">
              <i className="fa fa-fw fa-user" />
              <span>Users</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/admin">
              <i className="fa fa-fw fa-users-cog" />
              <span>Admin</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/notification">
              <i className="fa fa-envelope" />
              <span>Notification</span>
            </NavLink>
          </li>
          <hr className="sidebar-divider" />

          <div className="sidebar-heading">Trade</div>

          <li className="nav-item">
            <NavLink className="nav-link" to={"/gcards"}>
              <i className="fa fa-fw fa-tasks" />
              <span>Gift Cards</span>
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to={"/bitcoins"}>
              <i className="fa fa-fw fa-tasks" />
              <span>Bitcoins</span>
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to={"/trade-types"}>
              <i className="fa fa-fw fa-tasks" />
              <span>Trade Type</span>
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to={"/trade-responses"}>
              <i className="fa fa-fw fa-tasks" />
              <span>Trade Response</span>
            </NavLink>
          </li>

          <hr className="sidebar-divider" />

          <div className="sidebar-heading">Transactions</div>

          <li className="nav-item">
            <NavLink className="nav-link" to={"/debits"}>
              <i className="fa fa-fw fa-money-bill-alt" />
              <span>Fund Withdrawals</span>
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to={"/credits"}>
              <i className="fa fa-fw fa-money-bill-alt" />
              <span>Fund Wallet</span>
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to={"/buy-bitcoins"}>
              <i className="fa fa-fw fa-money-bill-alt" />
              <span>Bitcoin Purchase Logs</span>
            </NavLink>
          </li>

          <hr className="sidebar-divider" />

          <div className="sidebar-heading">Card Settings</div>

          {/* <li className="nav-item">
            <NavLink className="nav-link" to={'/cards'}>
              <i className="fa fa-fw fa-tasks" />
              <span>Cards</span>
            </NavLink>
          </li> */}
          <li className="nav-item">
            <NavLink className="nav-link" to={"/card-codes"}>
              <i className="fa fa-fw fa-tasks" />
              <span>Card Codes</span>
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to={"/closed-trades"}>
              <i className="fa fa-fw fa-tasks" />
              <span>Closed Trades</span>
            </NavLink>
          </li>
          {/* <li className="nav-item">
            <NavLink className="nav-link" to={'/card-types'}>
              <i className="fa fa-fw fa-tasks" />
              <span>Card Type</span>
            </NavLink>
          </li> */}

          {/* <li className="nav-item">
            <NavLink className="nav-link" to={'/card-currencies'}>
              <i className="fa fa-fw fa-tasks" />
              <span>Card Currency</span>
            </NavLink>
          </li> */}

          {/* <li className="nav-item">
            <NavLink className="nav-link" to={'/card-ranges'}>
              <i className="fa fa-fw fa-tasks" />
              <span>Card Range</span>
            </NavLink>
          </li> */}

          {/* <li className="nav-item">
            <NavLink className="nav-link" to={'/card-receipts'}>
              <i className="fa fa-fw fa-tasks" />
              <span>Receipt Type</span>
            </NavLink>
          </li> */}

          <hr className="sidebar-divider" />

          <div className="sidebar-heading">Bitcoin Settings</div>

          <li className="nav-item">
            <NavLink className="nav-link" to={"/bwallet-types"}>
              <i className="fa fa-fw fa-tasks" />
              <span>Wallet Type</span>
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to={"/btcrates"}>
              <i className="fa fa-fw fa-tasks" />
              <span>BTC Purchase Rate</span>
            </NavLink>
          </li>

          <hr className="sidebar-divider" />
          <li className="nav-item">
            <NavLink className="nav-link" to="/feedbacks">
              <i className="fa fa-comments" />
              <span>Feedbacks</span>
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to="/logout">
              <i className="fas fa-fw fa-sign-out-alt" />
              <span>Logout</span>
            </NavLink>
          </li>

          <hr className="sidebar-divider d-none d-md-block" />

          <div className="text-center d-none d-md-inline">
            <button className="rounded-circle border-0" id="sidebarToggle" />
          </div>
        </ul>
      )}
    </React.Fragment>
  );
};

export default SideBar;
